import { render, staticRenderFns } from "./addEventRulesOne.vue?vue&type=template&id=5642d226&scoped=true&"
import script from "./addEventRulesOne.vue?vue&type=script&lang=js&"
export * from "./addEventRulesOne.vue?vue&type=script&lang=js&"
import style0 from "./addEventRulesOne.vue?vue&type=style&index=0&id=5642d226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642d226",
  null
  
)

export default component.exports